import React, { Dispatch, Ref, SetStateAction } from 'react';
import { FlatList, StyleSheet } from 'react-native';
import TemplateListItem from './components/TemplateListItem';
import isMobile from '../../../../IsMobile';
import { Template } from '../../../../../constants/Types';

interface TemplateListProps {
  templateList: Ref<FlatList>,
  primedTemplateId: string,
  setPrimedTemplateId: Dispatch<SetStateAction<string>>,
  data: Template[],
  testID?: string,
}

const TemplateList = ({
  templateList, primedTemplateId, setPrimedTemplateId, data, testID,
}: TemplateListProps) => <FlatList
    ref={templateList}
    onScrollToIndexFailed={() => { }}
    style={styles.container}
    contentContainerStyle={styles.scrollViewContent}
    renderItem={({ item: template, index }) => <TemplateListItem
      key={`template_option_${template.id}`}
      {...template}
      selected={primedTemplateId === template.id}
      onPress={() => setPrimedTemplateId(template.id)}
      testID={`preset-template#${index + 1}`}
    />}
    {...{ data, testID }}
    keyExtractor={(template) => `template_option_${template.id}`}
    initialNumToRender={300}
  />;

const styles = StyleSheet.create({
  container: {
    maxHeight: 300,
    minHeight: undefined,
    marginHorizontal: isMobile ? undefined : 24,
  },
  scrollViewContent: {
    paddingHorizontal: isMobile ? 16 : 16,
    paddingVertical: 12,
  },
});

export default TemplateList;
